// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'search-analytics';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M14.167 7.36a6.798 6.798 0 0 1-10.994 5.347M.6 7.973a6.796 6.796 0 0 1 11.516-5.48m.06 9.673 5.261 5.272m.001-12.698V1.126h-3.606' />
    <path d='m.563 12.375 6.24-6.238a.711.711 0 0 1 1.004 0L9.64 7.973a.71.71 0 0 0 1.005 0l6.791-6.848' />
  </g>
);

export const viewBox = '0 0 18 18';
